export default __webpack_public_path__ + "2fae964b0d6668f02fd798a78047d1ad.png";